import React, { Suspense, lazy } from 'react';

// Import only above-the-fold sections normally
import CarouselComponent from '../components/HomeSections/CarouselComponent';
import WelcomeSection from '../components/HomeSections/WelcomeSection';

// Lazy load below-the-fold sections
const AboutUsSection = lazy(() => import('../components/HomeSections/AboutUsSection'));
const VeterinariansSection = lazy(() => import('../components/HomeSections/VeterinariansSection'));
const ProductSlider = lazy(() => import('../components/HomeSections/ProductSlider'));
const ProductSpotlight = lazy(() => import('../components/HomeSections/ProductSpotlight'));
const UnlockingSlider = lazy(() => import('../components/HomeSections/UnlockingSlider'));
const BlogSlider = lazy(() => import('../components/HomeSections/BlogSlider'));

function Home() {
    return (
        <>
            {/* Immediately visible content */}
            <CarouselComponent />
            <WelcomeSection />

            {/* Lazy loaded sections */}
            <Suspense fallback={<div>Loading...</div>}>
                <AboutUsSection />
                <VeterinariansSection />
                <ProductSlider />
                <ProductSpotlight />
                <UnlockingSlider />
                <BlogSlider />
            </Suspense>
        </>
    );
}

export default Home;
